import FormProps from 'components/FormProps';
import UploadResource from 'models/upload/resource';
import { Alert, Form, InputGroup } from 'react-bootstrap';
import React from 'react';
import Moment from 'react-moment';

export type Props = FormProps<UploadResource>;

export const Delete = ({ value, disabled, error }: Props) => (
  <>
    <Form.Group className="form-group">
      <InputGroup>
        <InputGroup.Text>Fil navn</InputGroup.Text>
        <Form.Control name="fileName" disabled={disabled} value={value.fileName} isInvalid={error?.fileName !== undefined} />
      </InputGroup>
    </Form.Group>
    <Form.Group className="form-group">
      <span>
        Upload dato:
        <Moment format="DD-MM-YYYY hh:mm:ss">{value.uploadDate}</Moment>
      </span>
    </Form.Group>
    <Alert variant="danger">
      Filen slettes permanent og kan ikke genskabes!
    </Alert>
  </>
);
export default Delete;
